import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { confService } from '../../../Services';

import Loader from '../../Common/Loader';
import Tabs from '../../Common/Tabs';
import LocationDetails from './LocationDetails';
import LocationSpecies from './LocationSpecies';
import NoAccess from '../../Common/NoAccess';

export const LocationEditForm = () => {
    const params = useParams();
    const [data, setData] = useState({});
    const [staffList, setStaffList] = useState([]);
    const [decompressionList, setDecompressionList] = useState([]);
    const [gearsList, setGearsList] = useState([]);
    const [gasMixturesList, setGasMixturesList] = useState([]);
    const [classificationsList, setClassificationsList] = useState([]);
    const [species, setSpecies] = useState([]);
    const [loading, setLoading] = useState(false);
    const modules = useSelector((state) => state.org.modules);

    const changeValue = (key, value) => {
        setData({
            ...data,
            [key]: value
        })
    }

    const changeSelectValue = (name, value, selectSetVar) => {
        selectSetVar(value);
        setData({
            ...data,
            [name]: Array.isArray(value) ? value.map(item => item.value).join(',') : (value ? value.value : ''),
        });
    }

    const fetchData = useCallback(async () => {
        setLoading(true);

        const res = await confService.editInfoLocation(params.id || 0);
        setData(res.location);
        setStaffList(res.staff);
        setDecompressionList(res.decompression || []);
        setGearsList(res.gears || []);
        setGasMixturesList(res.gasMixtures || []);
        setClassificationsList(res.classifications || []);
        setSpecies(res.species || []);

        setLoading(false);
    }, [params]);
    
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const tabs = [
        {
            title: <>Location details</>,
            content: <LocationDetails data={data} changeValue={changeValue} changeSelectValue={changeSelectValue} locationId={params.id || 0} staffList={staffList} decompressionList={decompressionList} gearsList={gearsList} gasMixturesList={gasMixturesList} classificationsList={classificationsList} modules={modules} />
        },
        modules.indexOf('Feedings') >= 0 && {
            title: <>Species</>,
            content: <LocationSpecies locationId={params.id || 0} speciesList={species} />
        }
    ];
    
    return (
        <>
            <h1>Edit location {data.Location}</h1>
            {loading ? <Loader /> : (data.LocationID ? <Tabs tabs={tabs} /> : <NoAccess />)}
        </>
    );
}

export default LocationEditForm;